import { render, staticRenderFns } from "./ParcelCheckItem.vue?vue&type=template&id=5469b980&scoped=true&"
import script from "./ParcelCheckItem.vue?vue&type=script&lang=js&"
export * from "./ParcelCheckItem.vue?vue&type=script&lang=js&"
import style0 from "./ParcelCheckItem.vue?vue&type=style&index=0&id=5469b980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469b980",
  null
  
)

export default component.exports